import React from 'react';
import { CheckCircle, Loader, XCircle, Minus } from 'lucide-react';

/**
 * Small status chip shown next to each POI in the block generator.
 *
 * @param {'none'|'building'|'built'|'error'} status
 * @param {number} [blockCount]
 */
const BlockStatusBadge = ({ status, blockCount }) => {
  switch (status) {
    case 'built':
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
          <CheckCircle className="w-3 h-3" />
          Built{blockCount != null ? ` (${blockCount})` : ''}
        </span>
      );

    case 'building':
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
          <Loader className="w-3 h-3 animate-spin" />
          Building…
        </span>
      );

    case 'error':
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700">
          <XCircle className="w-3 h-3" />
          Error
        </span>
      );

    default:
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500">
          <Minus className="w-3 h-3" />
          No blocks
        </span>
      );
  }
};

export default BlockStatusBadge;
